import type { NavItemConfig } from '@unifyapps/defs/types/interface';
import { MenuItem } from '@unifyapps/ui/components/Menu';
import { useLocaleDirection } from '@unifyapps/ui/hooks/useIsRtl';
import { ButtonMenuItem } from './ButtonMenuItem';
import { ColorSchemeSwitcher } from './ColorSchemeSwitcher';
import { LanguageSwitcher } from './LanguageSwitcher';

export const ApplicationMenuList = ({
  items,
  onAction,
  onMouseEnter,
  itemClassName,
  localeOptions,
}: {
  items: NavItemConfig[];
  onAction: (id: string) => void;
  onMouseEnter: (index: number) => void;
  itemClassName: (index: number, item: NavItemConfig) => string;
  localeOptions?: { value: string; label: string }[];
}) => {
  const direction = useLocaleDirection();
  return (
    <>
      {items.map((item, index) => {
        const className = itemClassName(index, item);

        switch (item.type) {
          case 'label':
            return (
              <MenuItem
                className={className}
                enableHoverEffect={false}
                index={index}
                key={item.id}
                onClick={(event) => {
                  event.stopPropagation();
                  onAction(item.id);
                }}
                onMouseEnter={() => onMouseEnter(index)}
                selected={item.selected}
                startDecoratorNode={item.startDecoratorNode}
                title={item.title}
                titleClassName={item.titleClassName}
              />
            );
          case 'BUTTON':
            return (
              <ButtonMenuItem
                className={className}
                enableKeyboardNavigation
                events={item.events}
                index={index}
                item={item}
                key={item.id}
                onMouseEnter={onMouseEnter}
              />
            );
          case 'COLOR_SCHEME_SWITCHER':
            return <ColorSchemeSwitcher direction={direction} key={item.id} />;
          case 'LANGUAGE_SWITCHER':
            return (
              <LanguageSwitcher direction={direction} key={item.id} localeOptions={localeOptions} />
            );
          default:
            return null;
        }
      })}
    </>
  );
};
